export const TUTOR_INPUT_BOTTOM_REM = 82;
export const TUTOR_INPUT_SIDE_PADDING_REM = 12;
export const TUTOR_INPUT_MAX_WIDTH = 720;
export const TUTOR_INPUT_OUTER_HEIGHT_REM = 56;
